// src/routes/AdminRoute.js
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, role } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated() || role !== "admin") {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
};

export default AdminRoute;
